import { Schema } from 'effect';

import { StringRequired } from '../primitive/string';

export const Password = StringRequired.check(Schema.isNonEmpty({ message: 'Vyplňte heslo!' }));
